import styled from "styled-components";
import { device } from "../device";

interface SearchbarProps {
    top: string;
}

export const SearchbarContainer = styled.div<SearchbarProps>`
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 12px;
    height: auto;
    z-index: 90;

    @media ${device.tablet} {
        height: 60px;
        grid-template-columns: 5fr 1fr;
        grid-template-rows: 60px;
        position: absolute;
        top: ${props => props.top};
        left: 0;
        right: 0;
    }

    .searchbar-subcontainer {

        display: flex;
        flex-direction: column;
        overflow: visible;
        
        @media ${device.tablet} {
            display: grid;
            grid-template-rows: 60px;
            grid-template-columns: 3fr 2fr;
        }
    }

    [placeholder]{
    text-overflow:ellipsis;
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        text-overflow:ellipsis;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        text-overflow:ellipsis;
    }
    :-ms-input-placeholder { /* IE 10+ */
        text-overflow:ellipsis;
    }
    :-moz-placeholder { /* Firefox 18- */
        text-overflow:ellipsis;
    }

  input {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: ${(props) => props.theme.colors.fontBlack};
    padding-left: 42px;
    background-position-x: 12px;



    @media ${device.tablet} {
        font-size: 17px;
        line-height: 20px;
        background-position-x: 24px;
        padding-left: 60px;
    }

    &::placeholder {
        color: ${(props) => props.theme.colors.fontLight};
    }

    &:focus {
        outline: none;
        box-shadow: ${(props) => props.theme.colors.primary};
    }
  }
`;

interface SearchbarTextInputProps {
    withTypeahead: boolean;
}

export const SearchbarTextInput = styled.input<SearchbarTextInputProps>`
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    border-top: none;
    border-left: none;
    border-bottom: 1px solid #d8d8d8;
    border-right: none;
    padding: 16px;
    background: url("data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.11 0.5C8.56352 0.500156 7.0396 0.844701 5.66579 1.50479C4.29199 2.16489 3.10827 3.12132 2.21373 4.29402C1.3192 5.46672 0.739871 6.82158 0.524253 8.24516C0.308635 9.66874 0.463 11.1196 0.974424 12.4764C1.48585 13.8331 2.33945 15.0562 3.46378 16.0433C4.5881 17.0304 5.95042 17.7527 7.43671 18.1498C8.923 18.5469 10.49 18.6073 12.0065 18.3258C13.5231 18.0443 14.945 17.4292 16.1533 16.532L23.3336 23.207C23.5365 23.3892 23.8082 23.49 24.0903 23.4877C24.3723 23.4854 24.6421 23.3802 24.8416 23.1948C25.041 23.0094 25.1541 22.7586 25.1566 22.4964C25.159 22.2342 25.0506 21.9816 24.8547 21.793L17.6743 15.118C18.8124 13.7939 19.5252 12.1979 19.7305 10.5138C19.9359 8.82966 19.6255 7.12586 18.8352 5.5985C18.0448 4.07113 16.8066 2.78228 15.263 1.88029C13.7194 0.978308 11.9332 0.499853 10.11 0.5ZM2.58005 9.5C2.58005 7.64348 3.37338 5.86301 4.78551 4.55025C6.19765 3.2375 8.11292 2.5 10.11 2.5C12.107 2.5 14.0223 3.2375 15.4344 4.55025C16.8466 5.86301 17.6399 7.64348 17.6399 9.5C17.6399 11.3565 16.8466 13.137 15.4344 14.4497C14.0223 15.7625 12.107 16.5 10.11 16.5C8.11292 16.5 6.19765 15.7625 4.78551 14.4497C3.37338 13.137 2.58005 11.3565 2.58005 9.5Z' fill='%239E9EA7'/%3E%3C/svg%3E%0A") no-repeat right #FFFFFF;
    background-size: 20px;
    border-radius: 12px 12px 0 0;

    @media ${device.tablet} {
        border-radius: 0;
        padding: 16px 24px;
        background-size: 24px 23px;
        border-right: 1px solid #9E9EA7;
        transition: all 0.3s ease;
        border-bottom: ${props => props.withTypeahead ? "1px solid #d8d8d8" : "none"};
        border-radius: ${props => props.withTypeahead ? "32px 0 0 0px" : "64px 0 0 64px"} ;
    }

    &:focus {
        background: url("data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.11 0.5C8.56352 0.500156 7.0396 0.844701 5.66579 1.50479C4.29199 2.16489 3.10827 3.12132 2.21373 4.29402C1.3192 5.46672 0.739871 6.82158 0.524253 8.24516C0.308635 9.66874 0.463 11.1196 0.974424 12.4764C1.48585 13.8331 2.33945 15.0562 3.46378 16.0433C4.5881 17.0304 5.95042 17.7527 7.43671 18.1498C8.923 18.5469 10.49 18.6073 12.0065 18.3258C13.5231 18.0443 14.945 17.4292 16.1533 16.532L23.3336 23.207C23.5365 23.3892 23.8082 23.49 24.0903 23.4877C24.3723 23.4854 24.6421 23.3802 24.8416 23.1948C25.041 23.0094 25.1541 22.7586 25.1566 22.4964C25.159 22.2342 25.0506 21.9816 24.8547 21.793L17.6743 15.118C18.8124 13.7939 19.5252 12.1979 19.7305 10.5138C19.9359 8.82966 19.6255 7.12586 18.8352 5.5985C18.0448 4.07113 16.8066 2.78228 15.263 1.88029C13.7194 0.978308 11.9332 0.499853 10.11 0.5ZM2.58005 9.5C2.58005 7.64348 3.37338 5.86301 4.78551 4.55025C6.19765 3.2375 8.11292 2.5 10.11 2.5C12.107 2.5 14.0223 3.2375 15.4344 4.55025C16.8466 5.86301 17.6399 7.64348 17.6399 9.5C17.6399 11.3565 16.8466 13.137 15.4344 14.4497C14.0223 15.7625 12.107 16.5 10.11 16.5C8.11292 16.5 6.19765 15.7625 4.78551 14.4497C3.37338 13.137 2.58005 11.3565 2.58005 9.5Z' fill='%230066CC'/%3E%3C/svg%3E%0A") no-repeat right #FFFFFF;
        background-size: 20px;
        background-position-x: 12px;

        @media ${device.tablet} {
            background-position-x: 24px;
            background-size: 24px 23px;
        }
    }
`;
export const SearchbarCityInput = styled.input<SearchbarTextInputProps>`
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    border: none;
    padding: 16px;
    background: url("data:image/svg+xml,%3Csvg width='20' height='24' viewBox='0 0 20 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0C12.5859 0 15.0658 1.02723 16.8943 2.85571C18.7228 4.68419 19.75 7.16414 19.75 9.75C19.75 13.87 16.855 18.36 11.14 23.268C10.8222 23.541 10.4171 23.6909 9.99813 23.6905C9.5792 23.6902 9.1743 23.5395 8.857 23.266L8.479 22.938C3.017 18.158 0.25 13.778 0.25 9.75C0.25 7.16414 1.27723 4.68419 3.10571 2.85571C4.93419 1.02723 7.41414 0 10 0V0ZM10 6C9.00544 6 8.05161 6.39509 7.34835 7.09835C6.64509 7.80161 6.25 8.75544 6.25 9.75C6.25 10.7446 6.64509 11.6984 7.34835 12.4017C8.05161 13.1049 9.00544 13.5 10 13.5C10.9946 13.5 11.9484 13.1049 12.6517 12.4017C13.3549 11.6984 13.75 10.7446 13.75 9.75C13.75 8.75544 13.3549 7.80161 12.6517 7.09835C11.9484 6.39509 10.9946 6 10 6Z' fill='%239E9EA7'/%3E%3C/svg%3E%0A") no-repeat right #FFFFFF;
    background-size: 20px;
    border-bottom: ${props => props.withTypeahead ? "1px solid #d8d8d8" : "none"};
    border-radius: ${props => props.withTypeahead ? "0" : "0 0 12px 12px"};

    @media ${device.tablet} {
        border-radius: 0;
        padding: 16px 24px;
        background-size: 20px 24px;
    }

    &:focus {
        background: url("data:image/svg+xml,%3Csvg width='20' height='24' viewBox='0 0 20 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0C12.5859 0 15.0658 1.02723 16.8943 2.85571C18.7228 4.68419 19.75 7.16414 19.75 9.75C19.75 13.87 16.855 18.36 11.14 23.268C10.8222 23.541 10.4171 23.6909 9.99813 23.6905C9.5792 23.6902 9.1743 23.5395 8.857 23.266L8.479 22.938C3.017 18.158 0.25 13.778 0.25 9.75C0.25 7.16414 1.27723 4.68419 3.10571 2.85571C4.93419 1.02723 7.41414 0 10 0V0ZM10 6C9.00544 6 8.05161 6.39509 7.34835 7.09835C6.64509 7.80161 6.25 8.75544 6.25 9.75C6.25 10.7446 6.64509 11.6984 7.34835 12.4017C8.05161 13.1049 9.00544 13.5 10 13.5C10.9946 13.5 11.9484 13.1049 12.6517 12.4017C13.3549 11.6984 13.75 10.7446 13.75 9.75C13.75 8.75544 13.3549 7.80161 12.6517 7.09835C11.9484 6.39509 10.9946 6 10 6Z' fill='%230066CC'/%3E%3C/svg%3E%0A") no-repeat right #FFFFFF;
        background-position-x: 12px;
        background-size: 20px;

        @media ${device.tablet} {
            background-size: 20px 24px;
            background-position-x: 24px;
        }
    }
`;

export const SearchbarTypeAhead = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: ${(props) => props.theme.colors.fontBlack};
    grid-column-start: 1;
    grid-column-end: 3;
    border-radius: 0 0 32px 32px;
    
    @media ${device.tablet} {
        font-size: 17px;
        line-height: 20px;
        background-position-x: 24px;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        border-radius: 0 0 32px 32px;
        overflow: hidden;

        li {    
            padding: 16px 24px;
            cursor: pointer;
            padding-left: 50px;
            background: url("data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.11 0.5C8.56352 0.500156 7.0396 0.844701 5.66579 1.50479C4.29199 2.16489 3.10827 3.12132 2.21373 4.29402C1.3192 5.46672 0.739871 6.82158 0.524253 8.24516C0.308635 9.66874 0.463 11.1196 0.974424 12.4764C1.48585 13.8331 2.33945 15.0562 3.46378 16.0433C4.5881 17.0304 5.95042 17.7527 7.43671 18.1498C8.923 18.5469 10.49 18.6073 12.0065 18.3258C13.5231 18.0443 14.945 17.4292 16.1533 16.532L23.3336 23.207C23.5365 23.3892 23.8082 23.49 24.0903 23.4877C24.3723 23.4854 24.6421 23.3802 24.8416 23.1948C25.041 23.0094 25.1541 22.7586 25.1566 22.4964C25.159 22.2342 25.0506 21.9816 24.8547 21.793L17.6743 15.118C18.8124 13.7939 19.5252 12.1979 19.7305 10.5138C19.9359 8.82966 19.6255 7.12586 18.8352 5.5985C18.0448 4.07113 16.8066 2.78228 15.263 1.88029C13.7194 0.978308 11.9332 0.499853 10.11 0.5ZM2.58005 9.5C2.58005 7.64348 3.37338 5.86301 4.78551 4.55025C6.19765 3.2375 8.11292 2.5 10.11 2.5C12.107 2.5 14.0223 3.2375 15.4344 4.55025C16.8466 5.86301 17.6399 7.64348 17.6399 9.5C17.6399 11.3565 16.8466 13.137 15.4344 14.4497C14.0223 15.7625 12.107 16.5 10.11 16.5C8.11292 16.5 6.19765 15.7625 4.78551 14.4497C3.37338 13.137 2.58005 11.3565 2.58005 9.5Z' fill='%239E9EA7'/%3E%3C/svg%3E%0A") no-repeat right #FFFFFF;
            background-size: 20px 24px;
            background-position-x: 16px;
            color: ${props => props.theme.colors.fontBlack};
        }
        li:hover {
            background-color: #FAFAFA;
        }
    }
`;

export const SearchbarButton = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
    width: 100%;
    border: none;
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    background-color: ${props => props.theme.colors.secondary};
    color: #FFFFFF;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
    border-radius: 16px;

    @media ${device.tablet} {
        border-radius: 0 64px 64px 0 ;
    }

    @media ${device.tablet} {
        height: 100%;
    }

    &>svg {
        margin-left: 12px;
    }

    &:hover {
        background: ${(props) => props.theme.colors.buttonPrimaryHover};
        border: none;
        color: ${(props) => props.theme.colors.fontWhite};
    }
`;